import { HttpHeaders } from '@angular/common/http';
import * as Interfaces from '../interfaces/api-request-model';

export class ApiRequestModel implements Interfaces.ApiRequestModel {
  public constructor(urlInput?: string, bodyInput?: any, tokenInput?: string,controllerName?:string,viewModelName?:string) {
    if (urlInput==null) {
        this.url='';
    }else{
        this.url = urlInput;
    }
    this.body = bodyInput;
    var foundedToken = localStorage.getItem('id_token');

    if (foundedToken == null) {
      foundedToken = '';
    }

    this.token = foundedToken;
    this.controllerName = controllerName;
    this.viewModelName = viewModelName;
  }

  public controllerName?: string;
  public viewModelName?: string;
  public url: string;
  public body?: any;
  public token?: string;
}
